import React, { useContext } from "react";
import { InlineLoading, Form, Modal } from "carbon-components-react";
import { Formik } from "formik";

import DollarInput from "web_modules/shared/carbon/DollarInput";
import { FinancialDataContext } from "../FinancialDataProvider";
import { validationSchema } from "./validation";

const styles = require("./styles.module.scss");

interface Props {
  onClose(): void;
}

const FinancialDataUpdateModal = ({ onClose }: Props) => {
  const { busy, financialData, updateData } = useContext(FinancialDataContext);

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={financialData}
      onSubmit={async (values, formikBag) => {
        formikBag.setStatus(undefined);
        updateData(values)
          .then(onClose)
          .catch(err => {
            if (err?.meta?.error_detail) {
              formikBag.setStatus(err?.meta?.error_detail);
            }
          });
      }}
    >
      {({ status, errors, handleBlur, handleChange, handleSubmit, values }) => (
        <Modal
          open
          size="sm"
          modalHeading=""
          onRequestClose={onClose}
          primaryButtonText="Save"
          primaryButtonDisabled={busy}
          secondaryButtonText="Cancel"
          preventCloseOnClickOutside
          onRequestSubmit={() => {
            handleSubmit();
          }}
        >
          <Form
            onSubmit={e => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <div className={styles.field}>
              <DollarInput
                id="prepaid_interest"
                name="prepaid_interest"
                value={values.prepaid_interest}
                labelText="Prepaid Interest"
                invalid={!!errors.prepaid_interest}
                invalidText={errors.prepaid_interest}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className={styles.field}>
              <DollarInput
                id="secondary_market_accrued_interest"
                name="secondary_market_accrued_interest"
                value={values.secondary_market_accrued_interest}
                labelText="Secondary Market Accrued Interest"
                invalid={!!errors.secondary_market_accrued_interest}
                invalidText={errors.secondary_market_accrued_interest}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className={styles.field}>
              <DollarInput
                id="sales_adjustments_and_or_penalties"
                name="sales_adjustments_and_or_penalties"
                value={values.sales_adjustments_and_or_penalties}
                labelText="Sales Adjustments and/or Penalties"
                invalid={!!errors.sales_adjustments_and_or_penalties}
                invalidText={errors.sales_adjustments_and_or_penalties}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className={styles.field}>
              <DollarInput
                id="interest_income"
                name="interest_income"
                value={values.interest_income}
                labelText="Interest Income"
                invalid={!!errors.interest_income}
                invalidText={errors.interest_income}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className={styles.field}>
              <DollarInput
                id="origination_proceeds"
                name="origination_proceeds"
                value={values.origination_proceeds}
                labelText="Origination Proceeds"
                invalid={!!errors.origination_proceeds}
                invalidText={errors.origination_proceeds}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className={styles.field}>
              <DollarInput
                id="other_revenue"
                name="other_revenue"
                value={values.other_revenue}
                labelText="Other Revenue"
                invalid={!!errors.other_revenue}
                invalidText={errors.other_revenue}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className={styles.field}>
              <DollarInput
                id="curtailments"
                name="curtailments"
                value={values.curtailments}
                labelText="Curtailments"
                invalid={!!errors.curtailments}
                invalidText={errors.curtailments}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className={styles.field}>
              <DollarInput
                id="additional_fees"
                name="additional_fees"
                value={values.additional_fees}
                labelText="Additional Fees"
                invalid={!!errors.additional_fees}
                invalidText={errors.additional_fees}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className={styles.field}>
              <DollarInput
                id="hedging_gains"
                name="hedging_gains"
                value={values.hedging_gains}
                labelText="Hedging Gains"
                invalid={!!errors.hedging_gains}
                invalidText={errors.hedging_gains}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </Form>
          {status && <InlineLoading status="error" description={status} />}
        </Modal>
      )}
    </Formik>
  );
};

export default FinancialDataUpdateModal;
